import React, { useState } from 'react';
import BranchTypeahead from './BranchTypeahead';
import PencilAltIcon from '@patternfly/react-icons/dist/esm/icons/pencil-alt-icon';

export interface EditableImageCellProps {
  imageValue: string;
  onChange: (newValue: string) => void;
  dummyImages: string[];
  disabled?: boolean;
  placeholder?: string;
}

const EditableImageCell: React.FC<EditableImageCellProps> = ({
  imageValue,
  onChange,
  dummyImages,
  disabled,
  placeholder
}) => {

  const pretty = (s: string) => {
    const m = s?.match?.(/^(\S+)\s+\((.+)\)$/);
    if (!m) return s || '';
    return (
      <span>
        {m[1]}
        <span style={{ marginLeft: 6, color: 'var(--text-muted)', fontSize: 12 }}>({m[2]})</span>
      </span>
    );
  };

  if (disabled) return <div style={{ opacity: 0.5 }}>{pretty(imageValue)}</div>; // non-clickable
  const [editing, setEditing] = useState(false);

  const handleSelect = (value: string) => {
    onChange(value);
    setEditing(false);
  };


  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {editing ? (
        <BranchTypeahead
          value={imageValue}
          onSelect={handleSelect}
          label="Select image"
          placeholder={placeholder}
          branchOptions={dummyImages.filter(Boolean)}
        />
      ) : (
        <>
          <span style={{ flexGrow: 1 }}>
            {imageValue ? pretty(imageValue) : <i>No image selected</i>}
          </span>
          <button
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              marginLeft: '5px',
            }}
            onClick={() => setEditing(true)}
            aria-label="Edit image"
          >
            <PencilAltIcon />
          </button>
        </>
      )}
    </div>
  );
};

export default EditableImageCell;
